import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateManagementUser } from '../../../common/api/clients/user.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useUserMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateManagementUser,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queries.members._def });
        },
    });
};
